import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ISupporterChatRepository } from 'application/repositorySchemas/ISupporterChatRepository';
import { type ISupporterSendChatClient } from 'interfaceAdapter/gatewaySchemas/ISupporterSendChatClient';

@injectable()
export class SupporterChatRepository implements ISupporterChatRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ISupporterSendChatClient')
        public readonly sendChatClient: ISupporterSendChatClient,
    ) {}

    public async send(chat_room_id: number, message: string): Promise<void> {
        const { message: resMessage } = await this.sendChatClient.post({
            token: this.supportUserToken.get() || '',
            chat_room_id,
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }
    }
}
